/**
 * Simple abstract class that will bind all methods to 'this'.
 *
 * Useful for scenarios where you have a controller class where methods must be called outside of the current 'this'
 * context. For example, adding event listeners to elements, or setting a timer with a method as a handler.
 */
export default abstract class ThisBound {
    constructor(bindOnly?: string[]) {
        let proto = this as object;

        while ((proto = Object.getPrototypeOf(proto)) !== Object.prototype) {
            for (const prop in proto) {
                if (proto.hasOwnProperty(prop) && typeof this[prop] === 'function' && prop !== 'constructor' && (! bindOnly || bindOnly.includes(prop))) {
                    this[prop] = this[prop].bind(this);
                }
            }
        }
    }
}